import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import { FeedbackStatusContent } from 'talent_matching/components/filters/feedback_status';
import { SCORECARD_STATUS } from 'talent_search/shared/types';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.feedback_status');

const FeedbackFilter = () => {
  const { watch, setValue } = useFormContext();
  const feedbackStatus = watch('feedbackStatus');

  const hasFilter = feedbackStatus !== SCORECARD_STATUS.ALL;
  const buttonLabel = t('title') + (hasFilter ? ' (1)' : '');

  const clear = () => {
    setValue('feedbackStatus', SCORECARD_STATUS.ALL, { shouldDirty: true });
  };

  return (
    <PopoverButton buttonLabel={buttonLabel} title={t('title')}>
      <Stack spacing={2}>
        <FeedbackStatusContent />
        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={clear} size="lg">
            {t('clear')}
          </TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default FeedbackFilter;
